<!-- Ana projeye eklenirken static textler dil dosyasına eklenmeli -->
<div class="viewer-card-body" style="display: flex; overflow: hidden">
  <div
    class="marker-controls tool-rail"
    *ngIf="!(viewerMode === '2D' && hide2DToolbar)"
  >
    <ng-container *ngIf="viewerMode === '3D'">
      <button
        class="control-btn btn-gizmo"
        [class.active]="isGizmoMode"
        (click)="onGizmoClick()"
        [title]="'modelViewer.moveModel' | translate"
      >
        <i class="fas fa-up-down-left-right"></i>
      </button>

      <button
        *ngIf="allowAnnotation"
        class="control-btn btn-add-marker"
        [class.active]="isAddMarkerMode"
        (click)="onMarkerClick()"
        [title]="'modelViewer.addMarker' | translate"
      >
        <i class="fas fa-map-marker-alt"></i>
      </button>


      <button
        *ngIf="!hide3DDeleteButton"
        [disabled]="isDeleteDisabled"
        [class.disabled-style]="isDeleteDisabled"
        class="control-btn btn-clear-all"
        (click)="onDeleteSelectedClick()"
        title="Delete Selected Marker"
      >
        <i class="fas fa-trash"></i>
      </button>

      <button
        [disabled]="isDeleteDisabled"
        [class.disabled-style]="isDeleteDisabled"
        class="control-btn btn-edit"
        (click)="onUpdateClick()"
        title="Update Marker"
      >
        <i class="fas fa-edit"></i>
      </button>

      <span
        class="marker-count clickable"
        [class.hidden]="!markersVisible"
        *ngIf="count > 0"
        (click)="onToggleClick()"
        title="Hide/Show Markers"
      >
        {{ count }}
      </span>
    </ng-container>

    <ng-container *ngIf="viewerMode === '2D'">
      <ng-container *ngIf="!hide2DToolbar">
        <button
          *ngIf="allowAnnotation"
          class="control-btn btn-add-marker"
          [class.active]="isDrawing2DMode"
          (click)="onDrawClick()"
          title="Draw Mode"
        >
          <i class="fas fa-pencil-alt"></i>
        </button>

        <button
          class="control-btn btn-gizmo"
          [class.active]="isSelect2DMode"
          (click)="onSelectClick()"
          title="Select Mode"
        >
          <i class="fas fa-mouse-pointer"></i>
        </button>
      </ng-container>
      <span
        class="marker-count clickable"
        [class.hidden]="!markersVisible"
        *ngIf="count > 0"
        (click)="onToggleClick()"
        [title]="'modelViewer.toggleMarkers' | translate"
      >
        {{ count }}
      </span>
    </ng-container>
  </div>
</div>
